import { ViewportScroller } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityVisibilityEnum } from '@sport-activities/sdk';

import { BadgeVariantEnum } from '~/component/badge/enums/variant.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { RatingSizeEnum } from '~/component/vtmn-rating/enums/RatingSize.enum';
import { Activity } from '~/core/model/activity.model';
import { SportsService } from '~/core/services/sports/sports.service';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { ParamethorNameEnum } from '~/paramethor/names.enum';

@Component({
  selector: 'app-activity-heading',
  templateUrl: './activity-heading.component.html',
  styleUrls: ['./activity-heading.component.scss'],
})
export class ActivityHeadingComponent {
  @Input() public activity: Activity;
  @Input() public averageRating?: number;
  @Input() public reviewCount?: number;

  public readonly badgeVariant = BadgeVariantEnum;
  public readonly iconTypeEnum = VtmnPlayIconTypeEnum;
  public readonly ratingSizeEnum = RatingSizeEnum;

  constructor(
    private readonly translateService: TranslateService,
    private readonly sportsService: SportsService,
    private readonly viewportScroller: ViewportScroller,
    protected readonly paramethorService: ParamethorService
  ) {}

  public get displayProficiencyLevel(): boolean {
    return !!this.activity?.proficiencyLevel;
  }

  public get hasAgeRange(): boolean {
    return Boolean(this.activity?.typicalAgeRange);
  }

  public get isPrivate(): boolean {
    return this.activity?.visibility === ('PRIVATE' as ActivityVisibilityEnum);
  }

  public get reviewsId(): string {
    return this.translateService.instant('activity.rating.anchor');
  }

  public get showExternalPaymentBadge(): boolean {
    return (
      this.paramethorService.isTrue(
        ParamethorNameEnum.AllowExternalPayment
      ) && this.activity?.startingPrice?.amount > 0
    );
  }

  public get externalPaymentBadgeVariant(): BadgeVariantEnum {
    return this.paramethorService.isTrue(
      ParamethorNameEnum.OnlinePaymentOutageBanner
    )
      ? BadgeVariantEnum.WARNING
      : BadgeVariantEnum.BORDER_GREY;
  }

  get sportName(): string {
    if (this.activity?.sports && this.activity?.sports?.length > 0) {
      return this.sportsService.getSport(this.activity?.sports[0])?.name || '';
    }
    return '';
  }

  public anchorHandler(event: MouseEvent): void {
    event.preventDefault();
    this.viewportScroller.scrollToAnchor(this.reviewsId);
  }
}
